module.exports = __webpack_public_path__ + "img/kairan.8e459059.png";